import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source"];

  static values = {
    show: String,
    hide: String,
  };

  connect() {
    this.showEl = document.getElementById(this.showValue);
    this.hideEl = document.getElementById(this.hideValue);
    this.sourceTarget.addEventListener("change", this.toggle.bind(this));
    this.toggle();
  }

  toggle(event) {
    event.preventDefault();
    if (this.sourceTarget.checked) {
      if (this.showEl) {
        this.showEl.classList.remove("hidden");
        this.setDisabled(this.showEl, false);
      }
      if (this.hideEl) {
        this.hideEl.classList.add("hidden");
        this.setDisabled(this.hideEl, true);
      }
    } else {
      if (this.showEl) {
        this.showEl.classList.add("hidden");
        this.setDisabled(this.showEl, true);
      }
      if (this.hideEl) {
        this.hideEl.classList.remove("hidden");
        this.setDisabled(this.hideEl, false);
      }
    }
  }

  setDisabled(container, disabled) {
    const inputs = container.querySelectorAll(
      "input, select, textarea, button",
    );
    inputs.forEach((input) => (input.disabled = disabled));
  }
}
